import * as React from 'react';
import { ViewStyle } from 'react-native';
import { Button, ButtonProperties } from 'secullum-react-native-ui';
import { Amarelo100 } from '../modules/layout';

// Cor de fundo dos botões de destaque (ações principais) do tema Secullum RH.
// Para botões passados como objeto ao ButtonBar/Card.Footer, use estiloBotaoDestaque.
export const estiloBotaoDestaque: ViewStyle = {
  backgroundColor: Amarelo100
};

// Botão de ação principal (CTA) com o amarelo de destaque do tema Secullum RH.
const BotaoDestaque = (props: ButtonProperties) => (
  <Button {...props} style={[estiloBotaoDestaque, props.style]} />
);

export default BotaoDestaque;
